export default __webpack_public_path__ + "static/media/Flag_of_Mozambique.4cebf734.svg";